import { render, staticRenderFns } from "./FaqPageCms.vue?vue&type=template&id=6c598b4c&scoped=true"
import script from "./FaqPageCms.vue?vue&type=script&lang=js"
export * from "./FaqPageCms.vue?vue&type=script&lang=js"
import style0 from "./FaqPageCms.vue?vue&type=style&index=0&id=6c598b4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c598b4c",
  null
  
)

export default component.exports